import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function ContractorIcon({ className }: Props) {
  return (
    <svg
      className={cn(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 17"
    >
      <path
        d="M10.0001 11.4167H6.25009C5.08711 11.4167 4.50563 11.4167 4.03246 11.5602C2.96713 11.8834 2.13345 12.717 1.81028 13.7824C1.66675 14.2555 1.66675 14.837 1.66675 16M13.3334 13.5L15.0001 15.1667L18.3334 11.8333M12.0834 4.75C12.0834 6.82107 10.4045 8.5 8.33342 8.5C6.26235 8.5 4.58341 6.82107 4.58341 4.75C4.58341 2.67893 6.26235 1 8.33342 1C10.4045 1 12.0834 2.67893 12.0834 4.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
